export default {
  granularity: 'Granularity',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  weekly: 'Weekly',
  week: 'Week',
  missingTitle: 'Missing title',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  q1: 'Q1',
  q2: 'Q2',
  q3: 'Q3',
  q4: 'Q4'
}
